// @flow
import * as React from 'react';
import SquareBoardCollage from 'app/common/react/components/profile/ProfileBoardCard/SquareBoardCollage';
import type { ImageType } from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';
import WideBoardCollage from 'app/common/react/components/profile/ProfileBoardCard/WideBoardCollage';
import {
  getCardWidth,
  getCardHeight,
} from 'app/common/react/components/profile/ProfileBoardCard/layout';

type Props = {|
  boardThumbs: Array<ImageType>,
  cover?: {|
    isCustom?: boolean,
    position?: { height: number, width: number, x: number, y: number },
    url: string,
  |},
  coverImagePos: {
    height: number,
    width: number,
    x: number,
    y: number,
  },
  coverPin?: {
    crop: Array<number>,
    image_url: string,
    size: Array<number>,
  },
  hasCustomCover: boolean,
  isInvite?: boolean,
  layout: 'square' | 'wide' | 'xWide' | 'xxWide',
  name: string,
|};

const BoardCollage = (props: Props) => {
  const {
    boardThumbs,
    cover,
    coverImagePos,
    coverPin,
    hasCustomCover,
    isInvite,
    layout,
    name,
  } = props;

  if (['wide', 'xWide', 'xxWide'].includes(layout)) {
    return (
      <WideBoardCollage
        width={getCardWidth(layout, isInvite)}
        height={getCardHeight(layout, isInvite)}
        boardThumbs={boardThumbs}
        cover={cover}
        coverPin={coverPin}
        numCols={3}
      />
    );
  } else if (layout === 'square') {
    return (
      <SquareBoardCollage
        boardName={name}
        boardThumbs={boardThumbs}
        coverImagePos={coverImagePos}
        coverImageUrl={(coverPin && coverPin.image_url) || ''}
        customCover={hasCustomCover}
        isInvite={isInvite}
      />
    );
  }

  return null;
};

export default BoardCollage;
